import { v4 as uuidv4 } from 'uuid';
import { Tab } from '../const';

/**
 * @function createSubtab
 * @param {array} tabs
 * @returns { array }
 */
function createSubtab(tabs) {
	const values = Array.from(tabs);

	const value = {
		[Tab.GroupId]: values[0].groupId,
		[Tab.Id]: String(uuidv4()),
		[Tab.Name]: 'New Sub Tab...',
		[Tab.Url]: 'Sub-menu',
		[Tab.Desc]: '',
		[Tab.Order]: String(values.length + 1),
		[Tab.Subtabs]: [],
		[Tab.Checked]: false,
		[Tab.SubtabId]: '',
		[Tab.Open]: false,
	};

	values.push(value);

	return values;
}

export default createSubtab;
